import { v4 as uuidv4 } from 'uuid'
import { VISA } from '../../constants'

function CobrandCard() {
    this.cobrandId = uuidv4()
    this.cardNetwork = VISA
    this.name = ''
    this.companyName = ''
    this.type = ''
    this.purpose = ''
    this.audience = ''
    this.cloudinaryId = ''
    this.compositeBackgroundAndLogoImage = ''
    this.previewImage = ''
    this.background = ''
    this.predesignBackgroundImageUrl = ''
    this.backgroundZoom = 1
    this.backgroundX = 0
    this.backgroundY = 0
    this.logo = ''
    this.logoZoom = 1
    this.logoX = 0
    this.logoY = 0
}

export default CobrandCard
